import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotIdSelectorComponent } from './chatbot-id-selector.component';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadSelectModule } from '../../typeahead-select/typeahead-select.module';


@NgModule({
  declarations: [ChatbotIdSelectorComponent],
  exports: [ChatbotIdSelectorComponent],
  imports: [
    CommonModule,
    TranslateModule,
    TypeaheadSelectModule
  ]
})
export class ChatbotIdSelectorModule { }
